export const N78 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Sales Performance (District)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'District Code',
                        "columnName": 'District Code',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'District Manager Name',
                        "columnName": 'District Manager Name',
                        "width": '230px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Territory Name',
                        "columnName": 'Territory Name',
                        "width": '310px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY_Q1',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 1st Qtr',
                        "columnName": 'Target_Q1',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                     {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY_Q2',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 2nd Qtr',
                        "columnName": 'Target_Q2',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    }, 
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY_Q3',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 3rd Qtr',
                        "columnName": 'Target_Q3',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY_Q4',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 4th Qtr',
                        "columnName": 'Target_Q4',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "DistrictManagerName",
                "endpoint": "N78",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}

export const N78_1 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Growth vs Last year by (District)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'District Code',
                        "columnName": 'DistrictCode',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'District Manager Name',
                        "columnName": 'DistrictManagerName',
                        "width": '230px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Territory Name',
                        "columnName": 'Territory Name',
                        "width": '310px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY 1st Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 1st Qtr',
                        "columnName": 'LY 1st Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                    {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY 2nd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 2nd Qtr',
                        "columnName": 'LY 2nd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY 3rd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 3rd Qtr',
                        "columnName": 'LY 3rd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                    {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY 4th Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 4th Qtr',
                        "columnName": 'LY 4th Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "DistrictManagerName",
                "endpoint": "N78.1",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}

export const N78_2 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Sales Performance (Territory)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Territory Code',
                        "columnName": 'Territory Code',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Territory Manager Name',
                        "columnName": 'PMR Name',
                        "width": '310px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Area Name',
                        "columnName": 'Area Nmae',
                        "width": '310px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'District Name',
                        "columnName": 'District Name',
                        "width": '310px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                     {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY_Q1',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 1st Qtr',
                        "columnName": 'Target_Q1',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                     {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY_Q2',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 2nd Qtr',
                        "columnName": 'Target_Q2',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                    {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY_Q3',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 3rd Qtr',
                        "columnName": 'Target_Q3',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                    {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY_Q4',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Target 4th Qtr',
                        "columnName": 'Target_Q4',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Perf',
                        "columnName": 'Perf_Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "DistrictManagerName",
                "endpoint": "N78.2",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}

export const N78_3 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Growth vs Last year by (Territory)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Territory Code',
                        "columnName": 'Territory Code',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Territory Manager Name',
                        "columnName": 'PMR Name',
                        "width": '230px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Area Name',
                        "columnName": 'Area Nmae',
                        "width": '310px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                        {
                        "name": 'District Name',
                        "columnName": 'District Name',
                        "width": '310px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'FY 1st Qtr',
                        "columnName": 'TY 1st Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 1st Qtr',
                        "columnName": 'LY 1st Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q1',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    
                    {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'TY 2nd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'FY 2nd Qtr',
                        "columnName": 'LY 2nd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q2',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'FY 3rd Qtr',
                        "columnName": 'TY 3rd Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 3rd Qtr',
                        "columnName": 'LY 3rd Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q3',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                    {
                        "name": 'FY 4th Qtr',
                        "columnName": 'TY 4th Qtr',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                     {
                        "name": 'LY 4th Qtr',
                        "columnName": 'LY 4th Qtr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Growth',
                        "columnName": 'Growth% Q4',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },

                ],
                "title": "Territory Manager",
                "endpoint": "N78.3",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}

export const QuarterSalesForce = {
  "sections": [
    N78,
    N78_1,
    N78_2,
    N78_3
  ]
}